import { FC, SVGAttributes } from 'react';

type GlowSvgProps = SVGAttributes<SVGElement>;

export const GlowSvg: FC<GlowSvgProps> = ({ ...props }) => {
    return (
        <svg
            width="119"
            height="119"
            viewBox="0 0 119 119"
            fill="none"
            {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M59.17 59.0677L34.0988 5.31203L53.958 0L59.17 59.0677ZM59.17 59.0677L64.382 0.000101223L84.2411 5.31214L59.17 59.0677ZM59.17 59.0677L93.2688 10.5151L107.807 25.0279L59.17 59.0677ZM59.17 59.0677L113.019 34.0399L118.34 53.8646L59.17 59.0677ZM59.17 59.0677L118.34 64.2707L113.019 84.0955L59.17 59.0677ZM59.17 59.0677L107.807 93.1075L93.2688 107.62L59.17 59.0677ZM59.17 59.0677L84.2413 112.823L64.3822 118.135L59.17 59.0677ZM59.17 59.0677L53.9579 118.135L34.0988 112.823L59.17 59.0677ZM59.17 59.0677L25.0711 107.62L10.5332 93.1075L59.17 59.0677ZM59.17 59.0677L0 64.2708L5.32123 84.0956L59.17 59.0677ZM25.0713 10.5151L59.17 59.0677L10.5334 25.0279L25.0713 10.5151ZM5.32129 34.0398L59.17 59.0677L5.27506e-05 53.8646L5.32129 34.0398Z"
                fill="url(#paint0_radial_4979_4610)"
            />
            <defs>
                <radialGradient
                    id="paint0_radial_4979_4610"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(59.3746 49.1202) rotate(-90.2401) scale(48.8042 48.8042)">
                    <stop stopColor="#05CBB8" stopOpacity="0.3" />
                    <stop offset="1" stopColor="#05CBB8" stopOpacity="0" />
                </radialGradient>
            </defs>
        </svg>
    );
};
